// extracted by mini-css-extract-plugin
module.exports = {"header":"ClientList_header__pOxMQ","card":"ClientList_card__3JQwi","content":"ClientList_content__6j66s","table":"ClientList_table__JG74b"};